import React from 'react';
import { C, HL, Lbl, Div } from './svgPrimitives';

export const levelCards3Visuals = {

  // ─── LEVEL 14 (7.1) Global Cues ──────────────────────────────────────────

  l14_c1401_global_india_link: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="4" y="28" width="52" height="30" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />
      <text x="30" y="40" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Global</text>
      <text x="30" y="51" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Markets</text>
      <rect x="76" y="28" width="52" height="30" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />
      <text x="102" y="40" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">FIIs</text>
      <text x="102" y="51" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Capital</text>
      <rect x="148" y="28" width="48" height="30" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="172" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">India</text>
      <text x="172" y="51" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Nifty</text>
      <line x1="56" y1="43" x2="76" y2="43" stroke="#f59e0b" strokeWidth="1.5" />
      <polygon points="76,43 70,40 70,46" fill="#f59e0b" />
      <line x1="128" y1="43" x2="148" y2="43" stroke="#16C784" strokeWidth="1.5" />
      <polygon points="148,43 142,40 142,46" fill="#16C784" />
      <text x="30" y="74" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">US -2%</text>
      <line x1="30" y1="66" x2="30" y2="58" stroke="#ef4444" strokeWidth="1.5" />
      <polygon points="30,58 27,64 33,64" fill="#ef4444" />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Global moves → FII flows → Nifty opens</text>
    </svg>
  ),

  l14_c1402_sgx_nifty: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="8" y="14" width="70" height="50" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />
      <text x="43" y="28" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">SGX Nifty</text>
      <text x="43" y="40" fill="#16C784" fontSize="9" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">22,450</text>
      <text x="43" y="52" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">8:45 AM</text>
      <rect x="8" y="74" width="70" height="22" rx="3" fill="#0f172a" stroke="#334155" strokeWidth="1" />
      <text x="43" y="83" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Prev close</text>
      <text x="43" y="92" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">22,200</text>
      <line x1="78" y1="39" x2="98" y2="39" stroke="#16C784" strokeWidth="1.5" />
      <polygon points="98,39 92,36 92,42" fill="#16C784" />
      <rect x="100" y="20" width="90" height="62" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="145" y="34" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Gap Up Preview</text>
      <text x="145" y="47" fill="#16C784" fontSize="10" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">+250 pts</text>
      <text x="145" y="59" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">+1.1%</text>
      <text x="145" y="72" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Do NOT chase</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SGX = gap preview before 9:15 AM</text>
    </svg>
  ),

  l14_c1403_us_markets_impact: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <text x="50" y="12" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Tuesday Night</text>
      <rect x="8" y="18" width="84" height="22" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />
      <text x="50" y="26" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Dow -600 pts</text>
      <text x="50" y="35" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Nasdaq -2.3%</text>
      <text x="50" y="55" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">↓ overnight</text>
      <text x="150" y="12" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Wednesday India</text>
      <rect x="108" y="18" width="84" height="22" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />
      <text x="150" y="26" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SGX -180 pts</text>
      <text x="150" y="35" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Gap down open</text>
      <C x={115} o={42} c={55} h={39} l={58} w={11} />
      <C x={129} o={55} c={66} h={53} l={68} w={11} />
      <C x={143} o={66} c={78} h={64} l={80} w={11} />
      <C x={157} o={78} c={70} h={68} l={82} w={11} />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">US close last night = India opening direction</text>
    </svg>
  ),

  l14_c1404_asian_session: (
    <svg viewBox="0 0 200 110" className="w-full">
      {[
        { x: 15, label: 'Tokyo', time: '8:00 AM', val: '-0.4%', col: '#ef4444' },
        { x: 76, label: 'Hang Seng', time: '8:15 AM', val: '-0.1%', col: '#f59e0b' },
        { x: 137, label: 'SGX', time: '8:45 AM', val: '-0.05%', col: '#16C784' },
      ].map((m, i) => (
        <g key={i}>
          <circle cx={m.x + 24} cy={38} r={16} fill="#1e293b" stroke={m.col} strokeWidth="1.5" />
          <text x={m.x + 24} y={34} fill={m.col} fontSize="7" textAnchor="middle" fontFamily="sans-serif">{m.label}</text>
          <text x={m.x + 24} y={44} fill={m.col} fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">{m.val}</text>
          <text x={m.x + 24} y={68} fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">{m.time}</text>
          {i < 2 && <line x1={m.x + 40} y1={38} x2={m.x + 58} y2={38} stroke="#334155" strokeWidth="1.5" strokeDasharray="4,2" />}
          {i < 2 && <polygon points={`${m.x + 58},38 ${m.x + 52},35 ${m.x + 52},41`} fill="#334155" />}
        </g>
      ))}
      <rect x="8" y="78" width="184" height="16" rx="3" fill="#16C784" opacity="0.1" stroke="#16C784" strokeWidth="1" />
      <text x="100" y="90" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Asia recovering → India gap less severe than expected</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Asian session = same-day confirmation signal</text>
    </svg>
  ),

  l14_c1405_dxy_fiis: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="4" y="15" width="58" height="42" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />
      <text x="33" y="28" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">DXY</text>
      <polyline points="10,48 18,42 26,36 34,30 42,25 50,22" fill="none" stroke="#f59e0b" strokeWidth="2" />
      <text x="33" y="52" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rising</text>
      <line x1="62" y1="36" x2="82" y2="36" stroke="#ef4444" strokeWidth="1.5" />
      <polygon points="62,36 68,33 68,39" fill="#ef4444" />
      <text x="72" y="30" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">FII</text>
      <text x="72" y="48" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">exits</text>
      <rect x="84" y="15" width="58" height="42" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />
      <text x="113" y="28" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">India</text>
      <text x="113" y="40" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">-₹4,200Cr</text>
      <text x="113" y="52" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">FII sells</text>
      <line x1="142" y1="36" x2="158" y2="36" stroke="#ef4444" strokeWidth="1.5" />
      <polygon points="158,36 152,33 152,39" fill="#ef4444" />
      <rect x="160" y="15" width="36" height="42" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <polyline points="165,22 170,28 175,35 180,40 185,45 190,50" fill="none" stroke="#ef4444" strokeWidth="2" />
      <text x="178" y="62" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Nifty ↓</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">DXY rises → FII sells India → Nifty headwind</text>
    </svg>
  ),

  l14_c1406_india_vix: (
    <svg viewBox="0 0 200 110" className="w-full">
      <path d="M 30,82 A 70,70 0 0,1 170,82" fill="none" stroke="#1e293b" strokeWidth="14" strokeLinecap="round" />
      <path d="M 30,82 A 70,70 0 0,1 79,30" fill="none" stroke="#16C784" strokeWidth="12" strokeLinecap="round" opacity="0.8" />
      <path d="M 79,30 A 70,70 0 0,1 128,25" fill="none" stroke="#f59e0b" strokeWidth="12" strokeLinecap="round" opacity="0.8" />
      <path d="M 128,25 A 70,70 0 0,1 170,82" fill="none" stroke="#ef4444" strokeWidth="12" strokeLinecap="round" opacity="0.8" />
      <line x1="100" y1="82" x2="138" y2="35" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="100" cy="82" r="5" fill="#ffffff" />
      <text x="42" y="98" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">&lt;15 Normal</text>
      <text x="100" y="18" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">15–25 Caution</text>
      <text x="162" y="98" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">&gt;25 Danger</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">VIX above 25 = reduce size or sit out</text>
    </svg>
  ),

  l14_c1407_crude_oil: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="12" y="30" width="44" height="52" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />
      <rect x="20" y="38" width="28" height="36" rx="2" fill="#f59e0b" opacity="0.2" />
      <rect x="20" y="52" width="28" height="22" rx="2" fill="#f59e0b" opacity="0.6" />
      <text x="34" y="88" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Crude</text>
      <text x="34" y="22" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">$82→$94</text>
      <line x1="56" y1="55" x2="76" y2="55" stroke="#ef4444" strokeWidth="1.5" />
      <polygon points="76,55 70,52 70,58" fill="#ef4444" />
      <rect x="78" y="30" width="56" height="52" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <text x="106" y="46" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Import bill ↑</text>
      <text x="106" y="58" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rupee 83→85</text>
      <text x="106" y="70" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">FII flows ↓</text>
      <line x1="134" y1="55" x2="150" y2="55" stroke="#ef4444" strokeWidth="1.5" />
      <polygon points="150,55 144,52 144,58" fill="#ef4444" />
      <rect x="152" y="30" width="40" height="52" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <polyline points="158,38 163,44 168,50 173,58 178,66 183,74" fill="none" stroke="#ef4444" strokeWidth="2" />
      <text x="172" y="84" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Nifty ↓</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Crude spike = macro headwind for India</text>
    </svg>
  ),

  l14_c1408_mixed_signals: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <rect x="4" y="15" width="88" height="68" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />
      <text x="48" y="28" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Some Green</text>
      <text x="48" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Nikkei +0.2%</text>
      <text x="48" y="52" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SGX -30 pts</text>
      <text x="48" y="64" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Crude flat</text>
      <rect x="108" y="15" width="88" height="68" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />
      <text x="152" y="28" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Some Red</text>
      <text x="152" y="40" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">US -0.3%</text>
      <text x="152" y="52" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">DXY flat</text>
      <text x="152" y="64" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">VIX 16</text>
      <text x="100" y="95" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">? No clear edge</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Mixed signals = wait for domestic price action</text>
    </svg>
  ),

  // ─── LEVEL 15 (7.2) Gap Analysis ─────────────────────────────────────────

  l15_c1501_what_is_gap: (
    <svg viewBox="0 0 200 110" className="w-full">
      <C x={12} o={72} c={58} h={54} l={74} w={14} />
      <C x={29} o={58} c={48} h={44} l={60} w={14} />
      <C x={46} o={50} c={62} h={46} l={64} w={14} />
      <C x={63} o={62} c={55} h={51} l={64} w={14} />
      <HL y={55} x1={4} x2={82} color="#94a3b8" dash />
      <Lbl x={83} y={58} text="Close 22,000" anchor="start" size={6.5} />
      <rect x={82} y={35} width={22} height={20} rx={2} fill="#f59e0b" opacity={0.15} stroke="#f59e0b" strokeWidth={1} />
      <text x="93" y="48" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">GAP</text>
      <HL y={35} x1={82} x2={200} color="#16C784" dash />
      <Lbl x={83} y={30} text="Open 22,180" anchor="start" color="#16C784" size={6.5} />
      <C x={108} o={38} c={28} h={24} l={40} w={14} />
      <C x={125} o={28} c={20} h={16} l={30} w={14} />
      <C x={142} o={22} c={14} h={10} l={24} w={14} />
      <C x={159} o={15} c={8}  h={5}  l={17} w={14} />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Gap = empty space between yesterday close and today open</text>
    </svg>
  ),

  l15_c1502_strong_gap_up: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={62} x1={4} x2={84} color="#94a3b8" dash />
      <Lbl x={5} y={58} text="Prev close 22,000" anchor="start" size={6} />
      <HL y={38} x1={84} x2={200} color="#16C784" dash />
      <Lbl x={85} y={34} text="Open 22,250 (+1.1%)" anchor="start" color="#16C784" size={6} />
      <C x={88}  o={40} c={26} h={22} l={42} w={12} />
      <C x={103} o={26} c={16} h={12} l={28} w={12} />
      <C x={118} o={50} c={38} h={35} l={52} w={12} />
      <circle cx="94" cy="20" r="5" fill="#ef4444" opacity="0.85" />
      <text x="110" y="18" fill="#ef4444" fontSize="7" fontFamily="sans-serif">Trap! Smart money sells</text>
      <C x={138} o={55} c={42} h={38} l={56} w={12} />
      <C x={153} o={42} c={30} h={26} l={44} w={12} />
      <C x={168} o={30} c={18} h={14} l={32} w={12} />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Strong gap up → spike → trap → do not chase open</text>
    </svg>
  ),

  l15_c1503_mild_gap_up: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={70} x1={4} x2={72} color="#94a3b8" dash />
      <Lbl x={5} y={66} text="Prev close 22,000" anchor="start" size={6} />
      <HL y={52} x1={72} x2={200} color="#16C784" dash />
      <Lbl x={73} y={48} text="Open 22,120 (+0.5%)" anchor="start" color="#16C784" size={6} />
      <C x={76}  o={54} c={50} h={46} l={56} w={11} />
      <C x={90}  o={50} c={48} h={44} l={52} w={11} />
      <text x="96" y="82" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Gap holds ✓</text>
      <C x={108} o={48} c={40} h={36} l={50} w={11} />
      <C x={122} o={40} c={30} h={26} l={42} w={11} />
      <C x={136} o={30} c={20} h={16} l={32} w={11} />
      <C x={150} o={20} c={12} h={8}  l={22} w={11} />
      <C x={164} o={12} c={6}  h={3}  l={14} w={11} />
      <circle cx="130" cy="28" r="5" fill="#16C784" opacity="0.85" />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Mild gap + holds 15 min = cleanest bullish setup</text>
    </svg>
  ),

  l15_c1504_flat_open_orb: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={52} x1={4} x2={100} color="#f59e0b" dash />
      <Lbl x={5} y={48} text="Range top 22,060" anchor="start" color="#f59e0b" size={6} />
      <HL y={72} x1={4} x2={100} color="#94a3b8" dash />
      <Lbl x={5} y={80} text="Range low 22,000" anchor="start" size={6} />
      <C x={8}  o={68} c={58} h={54} l={70} w={12} />
      <C x={23} o={58} c={65} h={54} l={68} w={12} />
      <C x={38} o={65} c={60} h={56} l={68} w={12} />
      <C x={53} o={60} c={66} h={56} l={70} w={12} />
      <C x={68} o={66} c={62} h={58} l={70} w={12} />
      <rect x={4} y={50} width={80} height={24} fill="#f59e0b" opacity={0.06} />
      <text x="44" y="95" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">ORB zone 9:15–9:45</text>
      <C x={98}  o={56} c={30} h={26} l={58} w={14} />
      <C x={115} o={30} c={18} h={14} l={32} w={14} />
      <C x={132} o={18} c={8}  h={4}  l={20} w={14} />
      <circle cx="105" cy="28" r="5" fill="#16C784" opacity="0.85" />
      <text x="145" y="24" fill="#16C784" fontSize="7" fontFamily="sans-serif">Breakout!</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Flat open = wait for range, trade the breakout</text>
    </svg>
  ),

  l15_c1505_mild_gap_down: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={32} x1={4} x2={72} color="#94a3b8" dash />
      <Lbl x={5} y={28} text="Prev close 22,000" anchor="start" size={6} />
      <HL y={52} x1={72} x2={200} color="#ef4444" dash />
      <Lbl x={73} y={62} text="Open 21,880 (-0.5%)" anchor="start" color="#ef4444" size={6} />
      <C x={76}  o={54} c={62} h={52} l={66} w={12} />
      <C x={91}  o={62} c={56} h={54} l={65} w={12} />
      <text x="96" y="82" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Recovery fails</text>
      <C x={110} o={56} c={64} h={54} l={68} w={12} />
      <C x={125} o={64} c={74} h={62} l={78} w={12} />
      <C x={140} o={74} c={84} h={72} l={88} w={12} />
      <C x={155} o={84} c={92} h={82} l={96} w={12} />
      <text x="163" y="102" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Continuation</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Mild gap down → wait → trade the direction</text>
    </svg>
  ),

  l15_c1506_strong_gap_down: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={18} x1={4} x2={72} color="#94a3b8" dash />
      <Lbl x={5} y={14} text="Prev close 22,000" anchor="start" size={6} />
      <HL y={52} x1={72} x2={200} color="#ef4444" dash />
      <Lbl x={73} y={62} text="Open 21,760 (-1.1%)" anchor="start" color="#ef4444" size={6} />
      <C x={76}  o={54} c={66} h={52} l={68} w={12} />
      <C x={91}  o={66} c={78} h={64} l={80} w={12} />
      <circle cx="103" cy="38" r="5" fill="#f59e0b" opacity="0.85" />
      <text x="120" y="34" fill="#f59e0b" fontSize="6.5" fontFamily="sans-serif">Counter rally trap</text>
      <C x={110} o={58} c={68} h={56} l={72} w={12} />
      <C x={125} o={68} c={78} h={66} l={82} w={12} />
      <C x={140} o={78} c={88} h={76} l={92} w={12} />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Strong gap down → reversal trap → wait 45 min</text>
    </svg>
  ),

  l15_c1507_first_15_min: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="4" y="20" width="84" height="64" rx="4" fill="#ef4444" opacity="0.08" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,2" />
      <text x="46" y="34" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">9:15 – 9:30 AM</text>
      <text x="46" y="46" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">OBSERVE ONLY</text>
      <C x={8}  o={42} c={28} h={24} l={70} w={11} />
      <C x={22} o={66} c={50} h={46} l={70} w={11} />
      <C x={36} o={52} c={68} h={50} l={72} w={11} />
      <C x={50} o={68} c={44} h={42} l={72} w={11} />
      <C x={64} o={46} c={58} h={44} l={70} w={11} />
      <text x="46" y="92" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Noise — not signal</text>
      <rect x="100" y="20" width="96" height="64" rx="4" fill="#16C784" opacity="0.08" stroke="#16C784" strokeWidth="1" />
      <text x="148" y="34" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">9:30 AM onwards</text>
      <text x="148" y="46" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">REAL SETUPS</text>
      <C x={104} o={55} c={42} h={38} l={57} w={12} />
      <C x={119} o={42} c={30} h={26} l={44} w={12} />
      <C x={134} o={30} c={18} h={14} l={32} w={12} />
      <C x={149} o={18} c={8}  h={4}  l={20} w={12} />
      <C x={164} o={8}  c={3}  h={1}  l={10} w={12} />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">First 15 min = observe. 9:30+ = trade.</text>
    </svg>
  ),

  l15_c1508_gap_fill_hold: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <text x="50" y="10" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Gap Fills</text>
      <HL y={28} x1={4} x2={94} color="#16C784" dash />
      <Lbl x={5} y={24} text="Gap open" color="#16C784" size={6} />
      <HL y={72} x1={4} x2={94} color="#94a3b8" dash />
      <Lbl x={5} y={80} text="Prev close" size={6} />
      <C x={8}  o={30} c={38} h={28} l={40} w={11} />
      <C x={22} o={38} c={50} h={36} l={52} w={11} />
      <C x={36} o={50} c={62} h={48} l={64} w={11} />
      <C x={50} o={62} c={72} h={60} l={74} w={11} />
      <C x={64} o={72} c={82} h={70} l={84} w={11} />
      <text x="44" y="100" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Filled → bearish signal</text>
      <text x="150" y="10" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Gap Holds</text>
      <HL y={28} x1={106} x2={196} color="#16C784" dash />
      <Lbl x={107} y={24} text="Gap open holds" color="#16C784" size={6} />
      <C x={108} o={30} c={26} h={22} l={32} w={11} />
      <C x={122} o={26} c={22} h={18} l={28} w={11} />
      <C x={136} o={22} c={18} h={14} l={24} w={11} />
      <C x={150} o={18} c={12} h={8}  l={20} w={11} />
      <C x={164} o={12} c={6}  h={3}  l={14} w={11} />
      <text x="150" y="100" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Held → bullish continuation</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Gap fill vs hold changes your entire trade plan</text>
    </svg>
  ),

  // ─── LEVEL 16 (7.3) Pre-Trade Playbook ──────────────────────────────────

  l16_c1601_why_checklist: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="4" y="20" width="46" height="36" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />
      <text x="27" y="36" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Impulse</text>
      <text x="27" y="48" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Looks good</text>
      <line x1="50" y1="38" x2="66" y2="38" stroke="#ef4444" strokeWidth="1.5" />
      <polygon points="66,38 60,35 60,41" fill="#ef4444" />
      <rect x="68" y="20" width="64" height="68" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />
      <text x="100" y="32" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Checklist</text>
      {['Global?', 'Gap?', 'Open?', 'Setup?', 'Size?'].map((t, i) => (
        <g key={i}>
          <rect x="74" y={38 + i * 10} width="52" height="8" rx="1" fill="#334155" />
          <text x="100" y={45 + i * 10} fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">{t}</text>
        </g>
      ))}
      <line x1="132" y1="38" x2="148" y2="38" stroke="#16C784" strokeWidth="1.5" />
      <polygon points="148,38 142,35 142,41" fill="#16C784" />
      <rect x="150" y="20" width="46" height="36" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="173" y="36" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Decision</text>
      <text x="173" y="48" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Grade</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Checklist replaces impulse with process</text>
    </svg>
  ),

  l16_c1602_five_step_check: (
    <svg viewBox="0 0 200 110" className="w-full">
      {[
        { n: '1', label: 'Global', col: '#6366F1' },
        { n: '2', label: 'Gap', col: '#f59e0b' },
        { n: '3', label: 'Open', col: '#16C784' },
        { n: '4', label: 'Setup', col: '#06b6d4' },
        { n: '5', label: 'Size', col: '#8b5cf6' },
      ].map((s, i) => (
        <g key={i}>
          <rect x={4 + i * 39} y={22} width={34} height={52} rx={4} fill="#1e293b" stroke={s.col} strokeWidth="1.5" />
          <text x={21 + i * 39} y={38} fill={s.col} fontSize="11" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">{s.n}</text>
          <text x={21 + i * 39} y={52} fill={s.col} fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">{s.label}</text>
          {i < 4 && <polygon points={`${38 + i * 39},48 ${38 + i * 39 - 4},44 ${38 + i * 39 - 4},52`} fill={s.col} opacity="0.6" />}
        </g>
      ))}
      <text x="100" y="88" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Each check upgrades or downgrades your grade</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">All 5, every time. Skip one = blind spot.</text>
    </svg>
  ),

  l16_c1603_grade_reading: (
    <svg viewBox="0 0 200 110" className="w-full">
      {[
        { grade: 'A', label: 'Full size', col: '#16C784', w: 170, y: 12 },
        { grade: 'B', label: 'Normal size', col: '#4ecca3', w: 135, y: 28 },
        { grade: 'C', label: 'Reduced size', col: '#f59e0b', w: 100, y: 44 },
        { grade: 'D', label: 'Minimum size', col: '#f97316', w: 65, y: 60 },
        { grade: '—', label: 'No trade', col: '#6b7280', w: 30, y: 76 },
      ].map((g, i) => (
        <g key={i}>
          <text x="18" y={g.y + 10} fill={g.col} fontSize="9" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">{g.grade}</text>
          <rect x="30" y={g.y + 2} width={g.w} height="10" rx="3" fill={g.col} opacity="0.75" />
          <text x={30 + g.w + 5} y={g.y + 10} fill={g.col} fontSize="6.5" textAnchor="start" fontFamily="sans-serif">{g.label}</text>
        </g>
      ))}
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Grade = size instruction. Follow it every time.</text>
    </svg>
  ),

  l16_c1604_contradictions: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="4" y="18" width="70" height="56" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="39" y="30" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Session</text>
      <text x="39" y="42" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bullish bias</text>
      <text x="39" y="54" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Green ✓ ✓ ✓</text>
      <polygon points="74,46 68,42 68,50" fill="#f59e0b" />
      <rect x="76" y="30" width="48" height="28" rx="4" fill="#f59e0b" opacity="0.15" stroke="#f59e0b" strokeWidth="1.5" />
      <text x="100" y="44" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">⚠</text>
      <text x="100" y="56" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Conflict</text>
      <polygon points="124,46 130,42 130,50" fill="#f59e0b" />
      <rect x="132" y="18" width="64" height="56" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <text x="164" y="30" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Instrument</text>
      <text x="164" y="42" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">PE Buy</text>
      <text x="164" y="54" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Bear direction</text>
      <text x="100" y="90" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Direction conflict detected → smaller size</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Contradiction = warning, not a hard stop</text>
    </svg>
  ),

  l16_c1605_sizing_conviction: (
    <svg viewBox="0 0 200 110" className="w-full">
      {[
        { grade: 'A', size: 100, col: '#16C784', label: '100% — Full' },
        { grade: 'B', size: 70,  col: '#4ecca3', label: '70% — Normal' },
        { grade: 'C', size: 45,  col: '#f59e0b', label: '45% — Reduced' },
        { grade: 'D', size: 20,  col: '#f97316', label: '20% — Minimum' },
      ].map((g, i) => (
        <g key={i}>
          <text x="18" y={18 + i * 22} fill={g.col} fontSize="8" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">{g.grade}</text>
          <rect x="28" y={8 + i * 22} width={g.size} height="14" rx="3" fill={g.col} opacity="0.7" />
          <text x={28 + g.size + 5} y={18 + i * 22} fill={g.col} fontSize="6.5" textAnchor="start" fontFamily="sans-serif">{g.label}</text>
        </g>
      ))}
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Same setup, different grades = different size</text>
    </svg>
  ),

  l16_c1606_sit_out: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <rect x="4" y="15" width="88" height="72" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <text x="48" y="28" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Monday</text>
      <text x="48" y="40" fill="#6b7280" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Sit Out</text>
      <text x="48" y="54" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹1,00,000</text>
      <text x="48" y="66" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Capital intact ✓</text>
      <rect x="108" y="15" width="88" height="72" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="152" y="28" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Tuesday</text>
      <text x="152" y="40" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Grade A</text>
      <text x="152" y="54" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Full size trade</text>
      <text x="152" y="66" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">+₹4,500 ✓</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Sit Out → capital intact → Grade A → full profit</text>
    </svg>
  ),

  // ─── LEVEL 17 (8.1) F&O Fundamentals ────────────────────────────────────

  l17_c1701_options_vs_equity: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <rect x="4" y="12" width="88" height="74" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />
      <text x="48" y="24" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Equity Share</text>
      <text x="48" y="36" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Ownership forever</text>
      <text x="48" y="48" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">No expiry ✓</text>
      <text x="48" y="60" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Can wait for recovery</text>
      <text x="48" y="72" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Value rarely = 0</text>
      <rect x="108" y="12" width="88" height="74" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1.5" />
      <text x="152" y="24" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Option Contract</text>
      <text x="152" y="36" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Right to buy/sell</text>
      <text x="152" y="48" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Expires on date ✗</text>
      <text x="152" y="60" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Can go to ₹0</text>
      <text x="152" y="72" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Direction + time needed</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Options expire. Shares don't.</text>
    </svg>
  ),

  l17_c1702_ce_vs_pe: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <rect x="4" y="12" width="88" height="76" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="48" y="26" fill="#16C784" fontSize="8.5" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">CE</text>
      <text x="48" y="38" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Call Option</text>
      <text x="48" y="52" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Right to BUY</text>
      <text x="48" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Profit when price ↑</text>
      <text x="48" y="78" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bullish view</text>
      <polygon points="48,22 40,30 56,30" fill="#16C784" opacity="0.6" />
      <rect x="108" y="12" width="88" height="76" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <text x="152" y="26" fill="#ef4444" fontSize="8.5" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">PE</text>
      <text x="152" y="38" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Put Option</text>
      <text x="152" y="52" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Right to SELL</text>
      <text x="152" y="64" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Profit when price ↓</text>
      <text x="152" y="78" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bearish view</text>
      <polygon points="152,84 144,76 160,76" fill="#ef4444" opacity="0.6" />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">CE = up bet. PE = down bet.</text>
    </svg>
  ),

  l17_c1703_buyer_vs_seller: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <rect x="4" y="12" width="88" height="76" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="48" y="24" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Option BUYER</text>
      <text x="48" y="36" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Pays ₹150 premium</text>
      <text x="48" y="48" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Max loss: ₹150 ✓</text>
      <text x="48" y="60" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Max gain: unlimited</text>
      <rect x="12" y="66" width="64" height="12" rx="2" fill="#16C784" opacity="0.3" />
      <text x="44" y="75" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Loss capped here</text>
      <rect x="108" y="12" width="88" height="76" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <text x="152" y="24" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Option SELLER</text>
      <text x="152" y="36" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Collects ₹150</text>
      <text x="152" y="48" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Max gain: ₹150 only</text>
      <text x="152" y="60" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Max loss: unlimited ✗</text>
      <polyline points="112,68 122,66 132,63 142,59 152,54 162,48 172,40 182,30" fill="none" stroke="#ef4444" strokeWidth="1.5" />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Buyer: limited loss. Seller: unlimited loss.</text>
    </svg>
  ),

  l17_c1704_what_is_premium: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="20" y="14" width="160" height="58" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />
      <rect x="20" y="14" width="120" height="58" rx="4" fill="#6366F1" opacity="0.25" />
      <rect x="20" y="14" width="40" height="58" rx="4" fill="#6366F1" opacity="0.5" />
      <text x="40" y="40" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Intrinsic</text>
      <text x="40" y="50" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Value</text>
      <text x="40" y="62" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹200</text>
      <text x="90" y="40" fill="#8b5cf6" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Time Value</text>
      <text x="90" y="52" fill="#8b5cf6" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹45</text>
      <text x="90" y="64" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">decays daily</text>
      <text x="155" y="40" fill="#334155" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">No value</text>
      <text x="155" y="52" fill="#334155" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">yet</text>
      <line x1="100" y1="10" x2="100" y2="78" stroke="#334155" strokeWidth="1" strokeDasharray="3,2" />
      <line x1="140" y1="10" x2="140" y2="78" stroke="#334155" strokeWidth="1" strokeDasharray="3,2" />
      <text x="100" y="88" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Total Premium = ₹200 + ₹45 = ₹245</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Time value shrinks every day. Intrinsic stays.</text>
    </svg>
  ),

  l17_c1705_itm_atm_otm: (
    <svg viewBox="0 0 200 110" className="w-full">
      <line x1="10" y1="55" x2="190" y2="55" stroke="#334155" strokeWidth="2" />
      <polygon points="190,55 183,51 183,59" fill="#334155" />
      {[
        { x: 30,  label: 'ITM',  sub: '22,000 CE',  price: '₹245',  col: '#16C784' },
        { x: 100, label: 'ATM',  sub: '22,200 CE',  price: '₹120',  col: '#f59e0b' },
        { x: 168, label: 'OTM',  sub: '22,500 CE',  price: '₹18',   col: '#ef4444' },
      ].map((p, i) => (
        <g key={i}>
          <circle cx={p.x} cy={55} r={7} fill={p.col} opacity="0.8" />
          <text x={p.x} y={37} fill={p.col} fontSize="7.5" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">{p.label}</text>
          <text x={p.x} y={27} fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">{p.sub}</text>
          <text x={p.x} y={75} fill={p.col} fontSize="7" textAnchor="middle" fontFamily="sans-serif">{p.price}</text>
        </g>
      ))}
      <line x1="100" y1="10" x2="100" y2="45" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" />
      <text x="100" y="8" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Nifty 22,200</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">ITM = already in profit. OTM = not yet.</text>
    </svg>
  ),

  l17_c1706_theta_decay: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={88} x1={18} x2={188} color="#334155" />
      <line x1="18" y1="10" x2="18" y2="88" stroke="#334155" strokeWidth="1.5" />
      <Lbl x={10} y={25} text="₹120" anchor="end" color="#16C784" />
      <Lbl x={10} y={44} text="₹88"  anchor="end" color="#f59e0b" />
      <Lbl x={10} y={60} text="₹52"  anchor="end" color="#f97316" />
      <Lbl x={10} y={76} text="₹18"  anchor="end" color="#ef4444" />
      <polyline points="28,23 76,42 124,58 172,74 186,87" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="28"  cy="23" r="4" fill="#16C784" />
      <circle cx="76"  cy="42" r="4" fill="#f59e0b" />
      <circle cx="124" cy="58" r="4" fill="#f97316" />
      <circle cx="172" cy="74" r="4" fill="#ef4444" />
      <text x="28"  y="96" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Mon</text>
      <text x="76"  y="96" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Tue</text>
      <text x="124" y="96" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Wed</text>
      <text x="172" y="96" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Thu</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Flat market → ₹120 became ₹18 by expiry</text>
    </svg>
  ),

  l17_c1707_open_interest: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={85} x1={15} x2={190} color="#334155" />
      <line x1="15" y1="10" x2="15" y2="85" stroke="#334155" strokeWidth="1" />
      {[
        { x: 25,  h: 18, col: '#16C784', label: '21,800 CE' },
        { x: 55,  h: 30, col: '#16C784', label: '22,000 CE' },
        { x: 85,  h: 50, col: '#16C784', label: '22,200 CE' },
        { x: 115, h: 72, col: '#ef4444', label: '22,500 CE', note: 'Max' },
        { x: 145, h: 40, col: '#16C784', label: '22,800 CE' },
        { x: 170, h: 20, col: '#16C784', label: '23,000 CE' },
      ].map((b, i) => (
        <g key={i}>
          <rect x={b.x} y={85 - b.h} width="20" height={b.h} rx="2" fill={b.col} opacity={b.note ? 1 : 0.5} />
          <text x={b.x + 10} y={95} fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">{b.label}</text>
          {b.note && <text x={b.x + 10} y={85 - b.h - 4} fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">{b.note} OI</text>}
        </g>
      ))}
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Max CE OI at 22,500 = resistance zone</text>
    </svg>
  ),

  l17_c1708_option_chain: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="4" y="8" width="192" height="88" rx="4" fill="#0f172a" stroke="#334155" strokeWidth="1" />
      {['CE OI', 'CE Prem', 'Strike', 'PE Prem', 'PE OI'].map((h, i) => (
        <text key={i} x={22 + i * 38} y={20} fill="#6366F1" fontSize="6" textAnchor="middle" fontFamily="sans-serif">{h}</text>
      ))}
      <line x1="8" y1="24" x2="192" y2="24" stroke="#334155" strokeWidth="1" />
      {[
        ['82L', '₹28', '22,500', '₹145', '12L', '#ef4444'],
        ['45L', '₹120', '22,200', '₹118', '44L', '#f59e0b'],
        ['18L', '₹245', '22,000', '₹38', '76L', '#16C784'],
      ].map((row, i) => (
        <g key={i}>
          {row.slice(0, 5).map((cell, j) => (
            <text key={j} x={22 + j * 38} y={35 + i * 16}
              fill={j === 2 ? row[5] : '#94a3b8'}
              fontSize={j === 2 ? '7' : '6.5'}
              fontWeight={j === 2 ? 'bold' : 'normal'}
              textAnchor="middle" fontFamily="sans-serif">{cell}</text>
          ))}
        </g>
      ))}
      <rect x="78" y="27" width="44" height="18" rx="2" fill="#f59e0b" opacity="0.1" stroke="#f59e0b" strokeWidth="0.75" />
      <text x="100" y="82" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">ATM highlighted. Max OI = key levels.</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Option chain = 60-second market context read</text>
    </svg>
  ),

  l17_c1709_futures_basics: (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="16" y="10" width="168" height="74" rx="6" fill="#1e293b" stroke="#8b5cf6" strokeWidth="1.5" />
      <text x="100" y="24" fill="#8b5cf6" fontSize="8" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">Nifty Futures Contract</text>
      <line x1="20" y1="28" x2="180" y2="28" stroke="#334155" strokeWidth="1" />
      {[
        ['Lot Size', '50 units'],
        ['Notional Value', '₹11,00,000'],
        ['Margin Required', '₹1,05,000 (~10%)'],
        ['Expiry', 'Last Thursday'],
      ].map((row, i) => (
        <g key={i}>
          <text x="26" y={40 + i * 14} fill="#94a3b8" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">{row[0]}</text>
          <text x="174" y={40 + i * 14} fill="#8b5cf6" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">{row[1]}</text>
        </g>
      ))}
      <text x="100" y="96" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">1% move = ₹5,500 P&L. Leverage = double-edged.</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Futures: no decay, but losses are uncapped</text>
    </svg>
  ),

  l17_c1710_expiry_rollover: (
    <svg viewBox="0 0 200 110" className="w-full">
      {['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].map((d, i) => {
        const isExpiry = i === 3;
        return (
          <g key={i}>
            <rect x={8 + i * 38} y={20} width={32} height={52} rx={3}
              fill={isExpiry ? '#ef4444' : '#1e293b'}
              stroke={isExpiry ? '#ef4444' : '#334155'} strokeWidth={isExpiry ? 2 : 1} />
            <text x={24 + i * 38} y={36} fill={isExpiry ? '#fff' : '#94a3b8'} fontSize="7" textAnchor="middle" fontFamily="sans-serif">{d}</text>
            {isExpiry && <text x={24 + i * 38} y={50} fill="#fff" fontSize="6" textAnchor="middle" fontFamily="sans-serif">EXPIRY</text>}
            {isExpiry && <text x={24 + i * 38} y={62} fill="#fff" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">3:30 PM</text>}
            {!isExpiry && i < 3 && <text x={24 + i * 38} y={50} fill="#334155" fontSize="6" textAnchor="middle" fontFamily="sans-serif">₹{['120','88','52'][i]}</text>}
          </g>
        );
      })}
      <rect x="4" y="82" width="192" height="16" rx="3" fill="#ef4444" opacity="0.08" stroke="#ef4444" strokeWidth="1" />
      <text x="100" y="93" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Expiry week: faster decay, higher volatility, reduce size</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">All F&O expires last Thursday. Plan exit before expiry day.</text>
    </svg>
  ),

  // ─── LEVEL 18 (8.2) F&O Risk ─────────────────────────────────────────────

  l18_c1801_options_zero: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={85} x1={15} x2={185} color="#334155" />
      <line x1="15" y1="10" x2="15" y2="85" stroke="#334155" strokeWidth="1" />
      <Lbl x={10} y={20} text="₹150" anchor="end" color="#16C784" />
      <Lbl x={10} y={43} text="₹90"  anchor="end" color="#f59e0b" />
      <Lbl x={10} y={64} text="₹30"  anchor="end" color="#f97316" />
      <Lbl x={10} y={85} text="₹0"   anchor="end" color="#ef4444" />
      <polyline points="25,18 68,41 115,62 165,84 182,85" fill="none" stroke="#ef4444" strokeWidth="2.5" />
      <circle cx="25"  cy="18" r="4" fill="#16C784" />
      <circle cx="68"  cy="41" r="4" fill="#f59e0b" />
      <circle cx="115" cy="62" r="4" fill="#f97316" />
      <circle cx="165" cy="84" r="4" fill="#ef4444" />
      <circle cx="182" cy="85" r="5" fill="#ef4444" />
      <text x="182" y="78" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹0</text>
      <HL y={85} x1={160} x2={196} color="#ef4444" />
      <text x="100" y="96" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">100% of premium gone at expiry</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Options expire worthless. This cannot happen with equity.</text>
    </svg>
  ),

  l18_c1802_otm_trap: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={82} x1={8} x2={192} color="#334155" />
      {[...Array(12)].map((_, i) => {
        const isWin = i === 9;
        const barH = isWin ? 50 : 4;
        const col = isWin ? '#16C784' : '#ef4444';
        return (
          <g key={i}>
            <rect x={10 + i * 15} y={82 - barH} width={11} height={barH} rx="1" fill={col} opacity={isWin ? 0.9 : 0.6} />
            {isWin && <text x={15 + i * 15} y={28} fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Win</text>}
          </g>
        );
      })}
      <text x="100" y="92" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">11 trades expire ₹0. 1 wins. Still net loss.</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">OTM options: cheap entry, poor probability</text>
    </svg>
  ),

  l18_c1803_sl_on_options: (
    <svg viewBox="0 0 200 110" className="w-full">
      <HL y={22} x1={15} x2={185} color="#16C784" dash />
      <Lbl x={16} y={18} text="Entry premium ₹120" color="#16C784" anchor="start" size={6.5} />
      <HL y={55} x1={15} x2={185} color="#f59e0b" />
      <Lbl x={16} y={51} text="SL at 50% → ₹60" color="#f59e0b" anchor="start" size={6.5} />
      <HL y={88} x1={15} x2={185} color="#ef4444" dash />
      <Lbl x={16} y={98} text="Do NOT wait for ₹0" color="#ef4444" anchor="start" size={6.5} />
      <polyline points="25,22 55,30 85,40 115,50 140,55" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" />
      <circle cx="140" cy="55" r="5" fill="#f59e0b" />
      <text x="158" y="52" fill="#f59e0b" fontSize="7" fontFamily="sans-serif">Exit here</text>
      <polyline points="140,55 158,62 172,70 183,80 190,88" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="4,2" />
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SL = 50% of premium. Exit before it decays to zero.</text>
    </svg>
  ),

  l18_c1804_selling_risk: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <rect x="4" y="18" width="88" height="68" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />
      <text x="48" y="30" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Sell CE ₹80</text>
      <text x="48" y="44" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Max gain:</text>
      <text x="48" y="56" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">₹3,000</text>
      <text x="48" y="70" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">if expires worthless</text>
      <rect x="108" y="18" width="88" height="68" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />
      <text x="152" y="30" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">If Nifty surges</text>
      <text x="152" y="44" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Max loss:</text>
      <text x="152" y="56" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">₹20,250</text>
      <text x="152" y="70" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">6.75x what you earned</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Selling options: risk ₹20K to make ₹3K — know this.</text>
    </svg>
  ),

  l18_c1805_expiry_week: (
    <svg viewBox="0 0 200 110" className="w-full">
      <Div />
      <text x="50" y="10" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Normal Week</text>
      <C x={8}  o={52} c={46} h={44} l={54} w={12} />
      <C x={23} o={46} c={54} h={44} l={56} w={12} />
      <C x={38} o={54} c={48} h={46} l={56} w={12} />
      <C x={53} o={48} c={56} h={46} l={58} w={12} />
      <C x={68} o={56} c={50} h={48} l={58} w={12} />
      <text x="47" y="80" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">50 pt move = ₹18 CE move</text>
      <text x="150" y="10" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Expiry Week</text>
      <C x={108} o={68} c={30} h={14} l={80} w={12} />
      <C x={123} o={32} c={72} h={20} l={82} w={12} />
      <C x={138} o={74} c={22} h={8}  l={82} w={12} />
      <C x={153} o={24} c={80} h={12} l={84} w={12} />
      <C x={168} o={82} c={18} h={6}  l={86} w={12} />
      <text x="155" y="80" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">50 pt move = ₹65 CE move</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Expiry week: same move = 3–4x premium impact</text>
    </svg>
  ),

  l18_c1806_fo_position_size: (
    <svg viewBox="0 0 200 110" className="w-full">
      <circle cx="70" cy="52" r="42" fill="#1e293b" stroke="#334155" strokeWidth="1.5" />
      <path d="M 70,52 L 70,10 A 42,42 0 0,1 113,52 Z" fill="#ef4444" opacity="0.7" />
      <path d="M 70,52 L 113,52 A 42,42 0 0,1 70,94 Z" fill="#16C784" opacity="0.15" />
      <path d="M 70,52 L 70,94 A 42,42 0 0,1 28,52 Z" fill="#6366F1" opacity="0.15" />
      <path d="M 70,52 L 28,52 A 42,42 0 0,1 70,10 Z" fill="#334155" opacity="0.4" />
      <text x="93" y="35" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">1–2%</text>
      <text x="93" y="45" fill="#ef4444" fontSize="6" textAnchor="middle" fontFamily="sans-serif">F&O Risk</text>
      <rect x="122" y="14" width="72" height="76" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />
      <text x="158" y="26" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹2,00,000 capital</text>
      <text x="158" y="38" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">1% = ₹2,000/trade</text>
      <line x1="126" y1="42" x2="190" y2="42" stroke="#334155" strokeWidth="0.5" />
      <text x="158" y="52" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">CE ₹75 × 37.5</text>
      <text x="158" y="62" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">= ₹2,812/lot</text>
      <text x="158" y="74" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">≈ 1.4% risk</text>
      <text x="158" y="84" fill="#94a3b8" fontSize="5.5" textAnchor="middle" fontFamily="sans-serif">Start with 1 lot</text>
      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">1–2% per F&O trade. Entire premium = your risk.</text>
    </svg>
  ),
};
